import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { AbntPipe } from '../../pipes/abnt.pipe';
import { EmpresaEtiquetaDadosService } from '../../services/etiqueta/empresa-etiqueta-dados.service';
import { OrdemProducaoDetalheStruct } from '../../services/structs/suprimentos/ordem-producao-detalhe.struct';

export interface ImpressaoNecessidadeMateriaisOrdemProducaoDialogData {
  ordens: OrdemProducaoDetalheStruct[];
}

/**
 * Impressão "Necessidade de materiais" (seção 7.1 da US#141200) — 1 página por OP, sempre lista
 * (o Detalhe manda `[ordem]`, a Lista manda N). Saldo é o total do produto (soma das localizações,
 * já vem em `item.saldoAtual` — a mesma composição usada nos diálogos de lançar estoque), sem
 * coluna Localização (o protótipo original já previa ela vazia).
 */
@Component({
  selector: 'app-impressao-necessidade-materiais-ordem-producao-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, AbntPipe],
  templateUrl: './impressao-necessidade-materiais-ordem-producao-dialog.component.html',
  styleUrl: './impressao-necessidade-materiais-ordem-producao-dialog.component.css',
})
export class ImpressaoNecessidadeMateriaisOrdemProducaoDialogComponent implements OnInit {
  public empresaNome = '';
  public empresaCnpj = '';
  public empresaEndereco = '';
  public empresaLogo = '';
  public carregandoEmpresa = true;

  constructor(
    public dialogRef: MatDialogRef<ImpressaoNecessidadeMateriaisOrdemProducaoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImpressaoNecessidadeMateriaisOrdemProducaoDialogData,
    private empresaEtiquetaDadosService: EmpresaEtiquetaDadosService,
  ) {}

  public async ngOnInit(): Promise<void> {
    // Os dados já vêm prontos via data.ordens — o cabeçalho de empresa é só decoração, uma falha
    // aqui não pode travar a impressão em "carregando" pra sempre.
    try {
      const valoresEmpresa = await this.empresaEtiquetaDadosService.getValoresEmpresa();
      this.empresaNome = valoresEmpresa['empresa.nome'];
      this.empresaCnpj = valoresEmpresa['empresa.cnpj'];
      this.empresaEndereco = valoresEmpresa['empresa.endereco_completo'];
      this.empresaLogo = valoresEmpresa['empresa.logo'];
    } catch {
      // Documento imprime sem o cabeçalho de empresa.
    }
    this.carregandoEmpresa = false;
  }

  public estoqueApos(saldoAtual: number | null, quantidadeTotal: number): number | null {
    return saldoAtual === null ? null : saldoAtual - quantidadeTotal;
  }

  /** Mesmo mecanismo usado por ImpressaoProdutoListaSimplesComponent e os demais `impressao-*`. */
  public imprimir(): void {
    const conteudoParaImprimir = document.querySelector('.modal-print-container');
    if (!conteudoParaImprimir) return;

    const janelaImpressao = window.open('', '', 'height=600,width=800');
    if (!janelaImpressao) return;

    const styles = Array.from(document.styleSheets)
      .map((styleSheet) => {
        try {
          return Array.from(styleSheet.cssRules).map((rule) => rule.cssText).join('');
        } catch {
          return '';
        }
      })
      .join('');

    janelaImpressao.document.write(`
      <html>
        <head>
          <title>Necessidade de materiais</title>
          <base href="/">
          <style>
            ${styles}
            html, body {
              height: auto !important;
              min-height: 0 !important;
              overflow: visible !important;
              margin: 20px;
              font-family: Roboto, "Helvetica Neue", sans-serif;
              color: #000;
              background: #fff;
            }
            .no-print { display: none !important; }
            .modal-print-container {
              display: block !important;
              width: 100% !important;
              height: auto !important;
              min-height: 0 !important;
              overflow: visible !important;
              box-shadow: none !important;
              margin: 0 !important;
              padding: 0 !important;
            }
          </style>
        </head>
        <body>
          ${conteudoParaImprimir.innerHTML}
        </body>
      </html>
    `);

    janelaImpressao.document.close();
    janelaImpressao.focus();

    setTimeout(() => {
      janelaImpressao.print();
      janelaImpressao.close();
    }, 800);
  }

  public fechar(): void {
    this.dialogRef.close();
  }
}
